import {EmailsObjectDto, FlyerPageSpotDto, IconStyleDto, PageRunsDto, PromoDto, UserRoleDto} from "../dtos";
import moment from "moment/moment";
import {iconStyles} from "./constans";
import {USER_ROLES} from "./Contants";

export const convertPagesRangeToString = (pageRange: PageRunsDto[]): string => {
    let pageRangeString: string = '';
    pageRange.forEach((range:PageRunsDto) => {
        if(range.startPageNo === range.endPageNo){
            pageRangeString += `${range.startPageNo},`;
        } else if(range.startPageNo < range.endPageNo){
            pageRangeString += `${range.startPageNo}-${range.endPageNo},`
        }
    });

    return pageRangeString.slice(0, -1);
}

//find unicode for letter (auto direction)
export const isUnicode = (str: string) => {
    let letters = [];
    for (let i = 0; i <= str.length; i++) {
        letters[i] = str.substring((i - 1), i);
        if (letters[i].charCodeAt(0) >= 1424 && letters[i].charCodeAt(0) <= 1535) {
            return true;
        }
    }
    return false;
}

export const getTotalPromotionsInFramesOnPage = (frames: FlyerPageSpotDto[]): PromoDto[] => {
    const totalPromotionsInFrames: PromoDto[] = [];
    frames?.forEach((frame: FlyerPageSpotDto) => {
        let promosFromFrame: PromoDto = frame.flyerPromos![frame.flyerPromos!.length - 1 < 0 ? 0 : frame.flyerPromos!.length - 1];
        if (promosFromFrame) {
            totalPromotionsInFrames.push({...promosFromFrame});
        }
    });
    return totalPromotionsInFrames;
}

export const getDate = (date: Date | undefined) => {
    return date ? moment(date).toDate() : null;
};

export const getIconStyle = (iconType: number): IconStyleDto => {
    return iconStyles.find((iconStyle: IconStyleDto) => iconStyle.iconStyleType === iconType) || iconStyles[0];
}

export const convertEmailsObjectToArray = (email: EmailsObjectDto): string[] => {
    return email ? Object.values(email).filter(email => email !== null && email !== '') : [];
}

export const findUserRole = (value: number): string => {
    const user: UserRoleDto | undefined = USER_ROLES.find((role: UserRoleDto) => {
        if(Number(role.value) === value){
            return role;
        }
    });
    if(user){
        return user.label;
    }
    return "Viewer";
}